if (!customElements.get('ly-learn-more-hero')) {
    customElements.define('ly-learn-more-hero', class extends HTMLElement {
        connectedCallback() {
            this.playBtn = this.querySelector('button')

            this.playBtn.addEventListener('click', this.handleClick)
        }

        disconnectedCallback() {
            this.playBtn.removeEventListener('click', this.handleClick)
        }

        #video = null
        get video() {
            if (!this.#video) {
                this.#video = this.querySelector('video')
            }
            return this.#video
        }

        handleClick = () => {
            if (this.playBtn.classList.contains('is-none')) return
            if (!this.video) return
            this.video.controls = true
            this.playBtn.classList.add('is-none')
            this.video.play()
        }

    })
}